import { useEffect } from "react";
import { X } from 'lucide-react';

export default function DeleteModal({ isOpen, onClose, onConfirm, title, message, confirmText = "Delete" }) {

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        handleClose();
      }
    };

    let originalOverflow;

    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
      originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = originalOverflow || "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-in fade-in duration-200"
      onClick={handleClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl max-w-lg w-full transform animate-in slide-in-from-bottom-4 duration-300 relative mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">
            {title || "Confirm Delete"}
          </h3>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors duration-200 cursor-pointer"
            aria-label="Close modal"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5">
          <p className="text-gray-600">
            {message || "Are you sure you want to delete this item? This action cannot be undone."}
          </p>
        </div>
        
        <div className="px-5 pb-5 flex justify-end gap-3 mt-2">
          <button
            onClick={handleClose}
            className="cursor-pointer px-5 py-2 bg-black text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="cursor-pointer px-5 py-2 bg-[#ff8c00] text-white text-sm font-medium rounded-lg hover:bg-[#e67e00] transition"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
